// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZOK7","rootNoMargin":"styles_rootNoMargin__1mzF8"};